export const SCALE = [
  { value: 0, label: "Not at all" },
  { value: 1, label: "Several days" },
  { value: 2, label: "More than half the days" },
  { value: 3, label: "Nearly every day" },
];

export const QUESTIONS = {
  phq9: [
    "Little interest or pleasure in doing things",
    "Feeling down, depressed, or hopeless",
    "Trouble falling or staying asleep, or sleeping too much",
    "Feeling tired or having little energy",
    "Poor appetite or overeating",
    "Feeling bad about yourself — or that you are a failure or have let yourself or your family down",
    "Trouble concentrating on things, such as reading or watching television",
    "Moving or speaking so slowly that other people could have noticed — or being so fidgety or restless that you have been moving around a lot more than usual",
    "Thoughts that you would be better off dead, or of hurting yourself in some way",
  ],
  gad7: [
    "Feeling nervous, anxious, or on edge",
    "Not being able to stop or control worrying",
    "Worrying too much about different things",
    "Trouble relaxing",
    "Being so restless that it's hard to sit still",
    "Becoming easily annoyed or irritable",
    "Feeling afraid as if something awful might happen",
  ],
};

export const INTAKE_FIELDS = [
  { key: "reason", label: "What brings you to therapy right now?", long: true },
  { key: "goals", label: "What would you like to be different after therapy?", long: true },
  { key: "history", label: "Any previous therapy, diagnoses or hospitalizations?", long: true },
  { key: "medications", label: "Current medications (name and dose)" },
  { key: "emergency_contact", label: "Emergency contact (name and phone)" },
  { key: "preferred_contact", label: "Best way and time to reach you" },
];
